import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
const FooterBranding = styled.img `
  width: clamp(9.775rem, 16.1vw, 16.1rem);
  height: auto;
  max-width: 100%;
  object-fit: contain;
  display: block;
`;
/**
 * Footer component that renders an footer branding image with specified dimensions.
 *
 * @returns {JSX.Element} The rendered footer image.
 */
export default function Footer() {
    return (_jsx(FooterBranding, { src: require('../../../../assets/images/footer.png'), alt: "Powered by Cisco Spaces" }));
}
